import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { isLcrpAvailable } from '../../../client/lib/macmillan'
import Clickable from '../../../client/components/Clickable'
import closeIcon from 'Assets/x-icon-white.svg'
import style from './style.css'
import baseStyle from 'Styles/base.css'
import parse from 'url-parse'

const query = parse(window.location, true).query

export default class CloseX extends Component {
  onCloseXClick () {
    if (this.props.closeAction) {
      this.props.closeAction()
    }
    if (query !== undefined && query.return_url !== undefined) {
      const url = decodeURIComponent(query.return_url)
      window.location = url
    } else {
      window.history.back()
    }
  }

  render () {
    // sometimes a referrer misbehaves, so let's avoid an error
    if (query !== undefined && query.return_url && !isValidURL(query.return_url)) {
      return (
        <div />
      )
    }
    let srText = 'Close Learning Curve'
    if (isLcrpAvailable()) {
      srText = 'Close Learning Curve Read & Practice'
    }
    return (
      <Clickable
        data-test-id="closelearningcurve"
        onClick={(event) => this.onCloseXClick()}
        className={style.closeXClick}
      >
        <input
          type="image"
          alt={srText}
          src={closeIcon}
          className={baseStyle.svgIcon}
        />
      </Clickable>
    )
  }
}

CloseX.propTypes = {
  returnUrl: PropTypes.string,
  closeAction: PropTypes.func
}

function isValidURL (str) {
  const a = document.createElement('a')
  a.href = decodeURIComponent(str)
  return (a.host && a.host !== window.location.host)
}
